module.exports = __webpack_public_path__ + "img/saas-analysis.8dfcb55e.svg";